import {Button, Stack, Typography} from '@mui/material';
import {AlertModal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {InstabilityErrorProps} from './types';

const {localizationInstabilityError} = translations['pt-br'].privateFlow.bookingFlow;

const InstabilityError = ({
	open,
	positionUnavailableOrTimeout,
	geolocationOrPermissionIsNotSupported,
	isUnprocessableError,
	onClose,
	onGoHome,
	onManualSelection,
	onRetry,
}: InstabilityErrorProps) => {
	const {isMobile} = useMediaQueries();

	const isError =
		positionUnavailableOrTimeout ||
		geolocationOrPermissionIsNotSupported ||
		isUnprocessableError;

	return (
		<AlertModal
		slotProps={{
			paper: {
				style: {
					maxWidth: 420,
					margin: isMobile ? 16 : 'auto',
					flex: isMobile ? 1 : 'initial',
				},
			},
		}}
			description={
				<Stack gap={2}>
					<Typography variant="h6" textAlign="center" fontSize={20}>
						{geolocationOrPermissionIsNotSupported
							? localizationInstabilityError.subtitle2
							: localizationInstabilityError.subtitle}
					</Typography>
					<Typography variant="body2" textAlign="center" fontSize={16}>
						{geolocationOrPermissionIsNotSupported
							? localizationInstabilityError.description2
							: localizationInstabilityError.description}
					</Typography>
				</Stack>
			}
			headerTitle={localizationInstabilityError.title}
			onClose={onClose}
			open={open}
			variant="info"
			footerContent={
				<Stack gap={1} width="100%">
					{isError ? (
						<Button
							onClick={onManualSelection}
							variant="contained"
							size="large"
							fullWidth>
							{localizationInstabilityError.primaryButton2}
						</Button>
					) : (
						<Button onClick={onRetry} variant="contained" size="large" fullWidth>
							{localizationInstabilityError.primaryButton}
						</Button>
					)}
					<Button onClick={onGoHome} variant="outlined" size="large" fullWidth>
						{localizationInstabilityError.secondaryButton}
					</Button>
				</Stack>
			}
		/>
	);
};

export {InstabilityError};
